<template>
    <div class="card-container">
        <div class="appManage flex-col vertical-center flow-center">
            <common-el-form :model="formModel" :rules="formRules" :submitData="submitData" @success="onSuccess"
                            @cancel="onCancel" submit-btn-text="提交" failTitle="提交失败" loadingText="提交中..."
                            :submitService="submitService" labelWidth="80px" :showButtonBox="showButtonBox">
                <div v-show="!showNext"  style="width: 100%">
                    <el-upload
                        v-show="!isRun"
                        class="upload-demo"
                        drag
                        ref="uploadFile"
                        prop="file"
                        :action="uploadUrl + '8883/tatApp/upload?uploadType=0'"
                        name="file"
                        :show-file-list="false"
                        :on-remove="handleRemove"
                        :on-success="handleSuccess"
                        :on-progress="handleProgress"
                        :before-upload="handleBeforeUpload">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                    <div class="flex-col vertical-center flow-center progressBox" v-show="isRun">
                        <p style="font-size: 20px">应用正在上传,请不要关闭浏览器</p>
                        <el-progress :text-inside="true" :stroke-width="35"
                                     :percentage="parseInt(progressInfo.percent ? progressInfo.percent : 0)"></el-progress>
                        <div class="flex-row vertical-center flow-center" style="font-size: 18px">
                            <p style="margin-right: 20px">{{fileInfo.name}}</p>
                            <p>{{parseInt(progressInfo.percent ? progressInfo.percent : 0)}}% / {{ Math.floor(((fileInfo.size ? fileInfo.size : 0) / 1024 / 1024)* 100) / 100}}MB</p>
                        </div>
                        <el-button type="primary"  class="button-size" @click="handleCancel">取消</el-button>
                    </div>
                </div>
                <div style="width: 100%" v-show="showNext">
                    <div class="head flex-col vertical-center flow-center">
                        <div class="iconImg" :style="'background: url('+ uploadUrl + commonUrl + resultInfo.icon +') center/cover no-repeat'"></div>
                        <p>{{appInfo.appName}}</p>
                        <p>版本 {{appInfo.versionName}} {{appInfo.versionCode}}</p>
                    </div>
                    <div  class="formBox">
                        <div class="flex-row vertical-center" v-if="!needTat" style="margin-bottom: 20px">
                            <p class="el-form-item__label label">所属机构</p>
                            <p>{{tatInfo.name}}</p>
                        </div>
                        <select-organs organName="所属机构" v-model="formModel.tatSimpleId" :selectValue="formModel.tatSimpleId" :needAll="false" selectWidth="100%"  v-show="needTat"></select-organs>
                        <!--<el-form-item label="所属机构" prop="tatSimpleId" v-show="needTat">-->
                            <!--<el-select v-model="formModel.tatSimpleId">-->
                                <!--<el-option-->
                                    <!--v-for="item in tatSimpleNames"-->
                                    <!--:key="item.id"-->
                                    <!--:label="item.simpleName"-->
                                    <!--:value="item.id">-->
                                <!--</el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->


                        <el-form-item label="更新机制" prop="forceUpdate">
                            <el-select v-model="formModel.forceUpdate">
                                <el-option
                                    v-for="item in forceUpdates"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否开启" class="app-switch">
                            <el-switch
                                v-model="formModel.status"
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="版本描述">
                            <el-input type="textarea" resize="none" rows="5" placeholder="请输入版本描述"
                                      v-model="formModel.versionDes"></el-input>
                        </el-form-item>
                    </div>

                </div>
            </common-el-form>
        </div>
    </div>
</template>

<script>
    import CommonElForm from 'components/common/CommonElForm'
    import SelectOrgans from 'components/business/SelectOrgans'

    import privateKey from 'service/constant/privateKey'
    import Server from 'common/conf/Server';
    import OrganService from 'service/OrganService'
    import APPService from 'service/APPService'
    import forceUpdatesTypes from 'service/constant/forceUpdatesTypes'
    import Regs from "common/conf/Regs";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import StorageService from 'store/interfaces';
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "appupload",
        components: {
            CommonElForm,
            SelectOrgans,
        },
        data() {
            return {
                uploadUrl: Server[process.env.NODE_ENV],
                commonUrl:'8883/tatApp/download/',
                formModel: {
                    tatSimpleId:'',
                    forceUpdate:'',
                    status:0,
                    versionDes:'',
                },
                formRules: {
                    tatSimpleId: [{
                        required: this.tatInfo == undefined,
                        message: '请选择机构简称',
                        trigger: 'change'
                    }],
                    forceUpdate: [{
                        required: true,
                        message: '请选择更新机制',
                        trigger: ['blur', 'change']
                    }],
                },
                resultInfo: {},
                appInfo: {},
                tatInfo: {},
                tatSimpleNames: [],
                isRun: false,
                showNext: false,
                showButtonBox: false,
                progressInfo: {},
                fileInfo: {},
                forceUpdates: forceUpdatesTypes,
                fileName:''
            }
        },
        mixins: [loadMixin, dialogMixin],
        mounted() {
            this.getSimpleNames();
        },
        computed: {
            needTat(){
                return this.tatInfo == undefined;
            },
            submitData() {
                let abbr = '';
                this.tatSimpleNames.forEach(item => {
                    if (item.id == this.formModel.tatSimpleId){
                        abbr = item.abbr
                    }
                });
                return {
                    recordId:this.resultInfo.id,
                    tatSimpleId: this.formModel.tatSimpleId,
                    status: this.formModel.status,
                    abbr: abbr,
                    forceUpdate: this.formModel.forceUpdate,
                    versionDes: this.formModel.versionDes,
                    userId:this.userId
                }
            },
            submitService() {
                return APPService.add;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods: {
            getSimpleNames() {
                this.doLoad(OrganService.simpleNames, '', res => {
                    this.doCheck(res, res => {
                        this.tatSimpleNames = res.contents;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.showSuccess(res.contents.optMsg);
                this.reloadApp(true);
                this.$router.back();
            },
            onCancel(res) {
                this.$router.back();
            },
            handleBeforeUpload(file) {
                const limitAndroid = file.type === 'application/vnd.android.package-archive';
                const limitIos = file.name.slice(file.name.length-3, file.name.length) === 'ipa';

                const limitSize = file.size != 0;
                if (!limitSize) {
                    this.$message.error(`上传文件不能为空`);
                }
                if (!limitAndroid && !limitIos){
                    this.$message.error(`不支持的文件类型`);
                }

                this.isRun = true;
                this.fileInfo = file;
                this.progressInfo = {};
                return limitSize && (limitAndroid || limitIos);
            },
            handleProgress(event, file, fileList) {
                this.progressInfo = event;
            },
            handleRemove(file, fileList) {
                this.isRun = false;
            },
            handleSuccess(res, file, fileList) {
                console.log(res, file, fileList)
                if ('0000' != res.respCode || (res.contents && res.contents.optStatus && '0000' != res.contents.optStatus)) {
                    this.handleCancel();
                    if (!res.contents) {
                        return this.showError(res.respMsg || res.respCode + ':未知错误');
                    }
                    return this.showError(res.contents.optMsg || res.contents.optStatus + ':未知错误');
                } else {
                    this.getAppInfo(res.respMsg, file.name);
                }
            },
            getAppInfo(id, fileName){
                this.doLoad(APPService.loadApp, {
                    recordId: id,
                    fileName: fileName
                }, res => {
                    this.doCheck(res, res => {
                        this.$message.success(res.respMsg);
                        this.resultInfo = res.contents;
                        this.appInfo = this.resultInfo.appInfo;
                        this.tatInfo = this.resultInfo.tatInfo;
                        if (this.resultInfo.tatInfo){
                            this.formModel.tatSimpleId = this.resultInfo.tatInfo.id
                        }
                        if (this.progressInfo.percent == 100){
                            this.showNext = true;
                            this.showButtonBox = true;
                            this.formModel.forceUpdate = 0;
                        }
                    });
                }, '信息获取失败')
            },
            handleCancel(){
                this.$refs.uploadFile.abort(this.fileInfo);
                this.$refs.uploadFile.clearFiles();
                this.isRun = false;
                this.showNext = false;
                this.progressInfo = {};
                this.fileInfo = {};
            },
            ...mapActions({
                reloadApp: StorageService.Reload.appAreaList,
            })
        }
    }
</script>

<style scoped>
    .appManage {
        margin: auto;
        border: 1px dashed #E6E6E6;
        padding: 30px;
        border-radius: 10px;
        min-height: 500px;
    }
    .button-size{
        margin-top: 30px;
    }

    .iconImg{
        width: 100px;
        height: 100px;
        border-radius: 10px;
        border: 1px solid #E6E6E6;
        margin-bottom: 10px;
    }

    .head{
        padding: 20px;
        border-bottom: 1px dashed #e6e6e6;
        margin-bottom: 30px;
    }
    .head p{
        margin-top: 5px;
    }

    .formBox{
        padding: 0 20%;
        margin: auto;
    }

    .label{
        width: 80px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/AppUpload.vue